


const LlCard = ({type, content, index}) => {

    if (type === "memory") {

        return (
            <div
            key={`memory-${index}`}
            style={{
                backgroundColor: 'rgba(240, 231, 217, 0.8)',
                borderRadius: '2.5em',
                padding: '2em',
                margin: '1em',
                boxShadow: '1px 1px 5px rgba(0, 0, 0, 0.5)',
            }}
            >
                <img 
                    src={content.img} 
                    alt={`Memory ${index + 1}`} 
                    style={{width: '20vw',                 
                    boxShadow: '1px 1px 5px rgba(0, 0, 0, 0.5)',
                    borderRadius: '1.5em',
            }}/>
                <p
                    style={{
                        fontSize: 'xxx-large',
                        textAlign: 'center',
                        wordWrap: 'break-word',
                        padding: '5px',
                        fontFamily: 'Sacramento'
                    }}
                >{content.text}</p>
            </div>
            
        );

    } else {
        return (
            <div
            key={`reason-${index}`}
            style={{
                backgroundColor: 'rgba(240, 231, 217, 0.8)',
                borderRadius: '2.5em',
                padding: '2em',
                margin: '1em',
                boxShadow: '1px 1px 5px rgba(0, 0, 0, 0.5)',
            }}
            >
                <p
                    style={{
                        fontSize: 'xxx-large',
                        textAlign: 'center',
                        wordWrap: 'break-word',
                        padding: '5px',
                        fontFamily: 'Sacramento'
                    }}
                >{content}</p>
            </div>

            
        );
    }
    
}
   

export default LlCard; 